const reasons: { [key: string]: any } = {
  man: [
    { name: 'नया ऑपरेटर हो (नई भरती )', value: 'level1' },
    {
      name: 'ऑपरेटर / इंस्पेक्टर दूसरी शिफ्ट में भी लगातार काम करता है I',
      value: 'level2',
    },

    { name: 'इंस्पेक्टर का Poison टेस्ट में फेल होन होना', value: 'level3' },
    {
      name: 'ऑपरेटर निरीक्षण या स्थल भ्रमण के दौरान WI के अनुसार कार्य नहीं करते पाए गए I',
      value: 'level4',
    },
    {
      name: 'ऑपरेटर 30 दिन से ज्यादा छुट्टी के बाद आता है',
      value: 'level5',
    },
    {
      name: 'सूचना के साथ छुट्टी पर ऑपरेटर (शिफ्ट शुरू होने से पहले)',
      value: 'level6',
    },
    {
      name: 'ऑपरेटर बिना सूचना के छुट्टी पर (शिफ्ट शुरू होने से ठीक पहले)',
      value: 'level7',
    },
    {
      name: 'ऑपरेटर अचानक बीमारी के कारण कार्यस्थल छोड़ देता है (उत्पादन शुरू होने के बाद)',
      value: 'level8',
    },
  ],
  material: [
    {
      name: 'पार्ट का मटेरियल चेंज है',
      value: 'level9',
    },
    {
      name: 'किसी अन्य एप्रूव्ड सोर्स के मेटेरियल का प्रयोग करना',
      value: 'level10',
    },
    {
      name: 'अन-एप्रूव्ड सोर्स/ किसी दुसरे ग्रेड के मेटेरियल का प्रयोग करना',
      value: 'level11',
    },
  ],
  method: [
    {
      name: 'प्रोसेस में सुधार / बदलाव ',
      value: 'level12',
    },
    {
      name: 'इंस्पेक्शन मेथड में बदलाव',
      value: 'level13',
    },
    {
      name: 'मशीन के पैरामीटर चेंज हुए हो',
      value: 'level14',
    },
    {
      name: 'इंस्ट्रूमेंट्/ गेज का केलिब्रेशन/  वेलिडेशन के लिये भेजना',
      value: 'level15',
    },
    {
      name: 'पोका योका में कमी ',
      value: 'level16',
    },
  ],
  machine: [
    {
      name: 'मशीन ब्रेकडाउन में आ गई',
      value: 'level17',
    },
    {
      name: 'चलते चलते टूल खराब हो गया या टूट गया',
      value: 'level18',
    },
    {
      name: 'मशीन/टूल प्रिवेंटिव मैंटेनस में आ गई',
      value: 'level19',
    },
    {
      name: 'Jig / Fixture प्रिवेंटिव मैंटेनस में आ गई',
      value: 'level20',
    },
    {
      name: 'हवा का दवाव  काम होना',
      value: 'level21',
    },
    {
      name: 'पॉवर कट',
      value: 'level22',
    },
  ],
};

const actionTakens: { [key: string]: any } = {
  level1: [
    {
      name: 'OJT अवधि (3 दिन) तक 100% सामग्री (पुर्जों) की जाँच।',
      value: 'action1',
    },
  ],
  level2: [
    {
      name: 'शिफ्ट को 12 घंटे से ज्यादा बढ़ा दिया गया है।',
      value: 'action1',
    },
  ],
  level3: [
    {
      name: 'इंस्पेक्टर को Poison टेस्ट   की ट्रेनिंग दोबारा दे I और फिर से टेस्ट ले I',
      value: 'action1',
    },
  ],
  level4: [
    {
      name: 'OJT अवधि (3 दिन) तक 100% सामग्री (पुर्जों) की जाँच।',
      value: 'action1',
    },
  ],
  level5: [
    {
      name: 'वही कौशल ऑपरेटर लंबी अवधि के बाद कार्य केंद्र पर प्रतिनियुक्त',
      value: 'action1',
    },
  ],
  level6: [
    {
      name: 'वही कौशल ऑपरेटर लंबी अवधि के बाद कार्य केंद्र पर प्रतिनियुक्त',
      value: 'action1',
    },
    {
      name: 'अगर उससे कम दक्षता का ऑपरेटर काम पर लगाना है तो',
      value: 'action2',
    },
  ],

  level7: [
    {
      name: 'उसी दक्षता का ऑपरेटर काम पर लगाना है',
      value: 'action1',
    },
    {
      name: 'अगर उससे कम दक्षता का ऑपरेटर काम पर लगाना है तो',
      value: 'action2',
    },
  ],
  level8: [
    {
      name: 'उसी दक्षता का ऑपरेटर काम पर लगाना है',
      value: 'action1',
    },
    {
      name: 'अगर उससे कम दक्षता का ऑपरेटर काम पर लगाना है तो',
      value: 'action2',
    },
  ],
  level9: [
    {
      name: 'प्रोडक्शन को रोको ओर ओक मटेरियल से प्रोडक्शन करे',
      value: 'action1',
    },
  ],
  level10: [
    {
      name: 'प्रोडक्शन को Continew करे',
      value: 'action1',
    },
  ],
  level11: [
    {
      name: 'प्रोडक्शन को रोको ओर डेविएशन फोम भरे',
      value: 'action1',
    },
  ],
  level12: [
    {
      name: 'ऑपरेटर को सुधार / बदलाव के बारे में बताना और उत्पादन करना',
      value: 'action1',
    },
  ],
  level13: [
    {
      name: 'पैरामीटर को रिसेट कर के मशीन को शुरु करे /',
      value: 'action1',
    },
  ],
  level14: [
    {
      name: 'कस्टमर को सूचित करना है तथा अप्रूवल लेना है',
      value: 'action1',
    },
  ],
  level15: [
    {
      name: 'प्रोडक्शन को दूसरे कैलिब्रेटेड इंस्ट्रूमेंट्/ गेज द्वारा शुरु करे /',
      value: 'action1',
    },
  ],
  level16: [
    {
      name: 'लाइन को बंद कर दे',
      value: 'action1',
    },
  ],
  level17: [
    {
      name: 'प्रोडक्शन कम या ज्यादा कैपेसिटी की मशीन पर काम करना',
      value: 'action1',
    },
    {
      name: 'सेम कपैसिटी की मशीन पर जॉब चलाये',
      value: 'action2',
    },
    {
      name: 'मशीन रिपेयर के बाद चालू करना',
      value: 'action3',
    },
  ],
  level18: [
    {
      name: 'दुसरे सेट के साथ प्रोडक्शन करना',
      value: 'action1',
    },
    {
      name: 'टूल रिपेयर के बाद चालू करना',
      value: 'action2',
    },
  ],
  level19: [
    {
      name: ' मशीन / टूल को प्रिवेंटिव मैंटेनस करने के बाद चलाना हैं',
      value: 'action1',
    },
  ],
  level20: [
    {
      name: 'Jig  / Fixture को प्रिवेंटिव मैंटेनस करने के बाद चलाना हैं',
      value: 'action1',
    },
  ],
  level21: [
    {
      name: 'पार्ट को कण्ट्रोल प्लान या मास्टर सैंपल से चेक करे',
      value: 'action1',
    },
  ],
  level22: [
    {
      name: 'पार्ट को कण्ट्रोल प्लान या मास्टर सैंपल से चेक करे',
      value: 'action1',
    },
  ],
};

const actionTakenTickMarks: { [key: string]: any } = {
  // man
  level1action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    setup: true,
    training: true,
    retro: false,
    suspected: true,
    procedure: `
    (B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval : 5 पीस चेक करके सेट अप अप्रूवल करे I
    (E) Containment (Suspected Lot) Check : ओपरेटर के द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 3 दिन तक मॉनिटर करें I  और 100%  पार्ट्स विसुअल चैक करें
    `,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर ',
  },
  level2action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: false,
    setup: true,
    retro: false,
    suspected: true,
    procedure: `(C) Set-up Approval : 5 पीस चेक करके सेट अप अप्रूवल करे I
    (E) Containment (Suspected Lot) Check : ओपरेटर के द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 2nd Shift material I  और 100%  पार्ट्स विसुअल चैक करें`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level3action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: true,
    setup: false,
    retro: true,
    suspected: true,
    procedure: `(B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (D) Retroactive Check :  लाइन पर चेक कीये हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level4action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: true,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval : 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive Check:  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I `,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level5action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: true,
    setup: true,
    retro: false,
    suspected: true,
    procedure: `(B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (E) Containment (Suspected Lot) Check : ओपरेटर द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 1 दिन तक मॉनिटर करें I 100%  पार्ट्स विसुअल चैक करें I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level6action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे|`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level6action2: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: true,
    setup: true,
    retro: false,
    suspected: true,
    procedure: `(B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (E) Containment (Suspected Lot) Check : ओपरेटर द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 1 दिन तक मॉनिटर करें I 100%  पार्ट्स विसुअल चैक करें`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level7action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे|`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level7action2: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: true,
    setup: true,
    retro: false,
    suspected: true,
    procedure: `(B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (E) Containment (Suspected Lot) Check : ओपरेटर द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 1 दिन तक मॉनिटर करें I 100%  पार्ट्स विसुअल चैक करें`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level8action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे|
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level8action2: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: true,
    setup: true,
    retro: true,
    suspected: true,
    procedure: `(B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I 
    (E) Containment (Suspected Lot) Check : ओपरेटर द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 1 दिन तक मॉनिटर करें I 100%  पार्ट्स विसुअल चैक करें`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  // material 
  level9action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(A)  Inform to customer     (ग्राहक को सूचित करें I)
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level10action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level11action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: false,
    suspected: true,
    procedure: `(A)  Inform to customer     (ग्राहक को सूचित करें I)
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive Check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I 
    (E) Containment (Suspected Lot) Check : ओपरेटर द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 1 दिन तक मॉनिटर करें I 100%  पार्ट्स विसुअल चैक करें`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  // method
  level12action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: true,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(A)  Inform to customer     (ग्राहक को सूचित करें I)
    (B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level13action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: true,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(A)  Inform to customer     (ग्राहक को सूचित करें I)
    (B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level14action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(A)  Inform to customer     (ग्राहक को सूचित करें I)
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive Check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I `,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level15action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level16action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive Check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I `,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  // machine
  level17action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: true,
    setup: true,
    retro: true,
    suspected: true,
    procedure: `(A)  Inform to customer     (ग्राहक को सूचित करें I)
    (B) ओपरेटर को Work Instructions  के अनुसर ऑन जॉब ट्रेनिंग दें|
    (C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I 
    (E) Containment (Suspected Lot) Check : ओपरेटर द्वारा बनाये गये पार्ट्स की 2 घंटे में 5 पीस की जगह 1 घंटे में 5 पीस की पेट्रोलिंग चेक करें और 1 दिन तक मॉनिटर करें I 100%  पार्ट्स विसुअल चैक करें`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level17action2: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level17action3: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level18action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level18action2: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: true,
    retro: true,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I
    (D) Retroactive check:-  लाइन पर बने हुए 100% पीस को अलग कर दे व 5 पीस की रिकॉर्डिंग करे और विसुअल 100 % चेक करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level19action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level20action1: {
    plan_unplaned: 'प्लांड',
    abnormal: 'X',
    training: false,
    setup: true,
    retro: false,
    suspected: false,
    procedure: `(C) Set-up Approval :- 5 पीस चेक करके सेट अप अप्रूवल करे I`,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level21action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: false,
    retro: false,
    suspected: false,
    procedure: `अगर मास्टर सैंपल और कण्ट्रोल प्लान से पार्ट ओके है तो मशीन को चालू रखे `,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
  level22action1: {
    plan_unplaned: 'अनप्लांड',
    abnormal: '√',
    training: false,
    setup: false,
    retro: false,
    suspected: false,
    procedure: `अगर मास्टर सैंपल और कण्ट्रोल प्लान से पार्ट ओके है तो मशीन को चालू रखे `,
    resp: 'प्रोडक्शन / क्वालिटी इंजीनियर',
  },
};
export { reasons, actionTakenTickMarks, actionTakens };
